import PropTypes from 'prop-types';

/**
 * Normalize and validate a user tier.
 * @param {unknown} value
 * @returns {'anonymous'|'free'|'premium'}
 */
export function normalizeTier(value) {
  if (value === 'premium' || value === 'free') {
    return value;
  }

  return 'anonymous';
}

/**
 * Normalize a usage snapshot coming from the usage API.
 * @param {unknown} snapshot
 * @returns {{limit: number|null, remaining: number|null, resetAt: string|null}|null}
 */
export function normalizeUsageSnapshot(snapshot) {
  if (!snapshot || typeof snapshot !== 'object') {
    return null;
  }

  const { limit, remaining, resetAt } = snapshot;

  const normalizedLimit = typeof limit === 'number' && Number.isFinite(limit) && limit >= 0 ? limit : null;
  const normalizedRemaining = typeof remaining === 'number' && Number.isFinite(remaining)
    ? Math.max(remaining, 0)
    : null;
  const normalizedResetAt = typeof resetAt === 'string' && resetAt.length > 0 ? resetAt : null;

  if (normalizedLimit === null && normalizedRemaining === null && normalizedResetAt === null) {
    return null;
  }

  return {
    limit: normalizedLimit,
    remaining: normalizedRemaining,
    resetAt: normalizedResetAt,
  };
}

/**
 * Determine whether a usage snapshot represents depleted quota.
 * @param {{remaining?: number|null}|null} usageMetadata
 * @returns {boolean}
 */
export function isUsageDepleted(usageMetadata) {
  if (!usageMetadata || typeof usageMetadata.remaining !== 'number') {
    return false;
  }

  return usageMetadata.remaining === 0;
}

export const usageMetadataPropType = PropTypes.shape({
  limit: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  remaining: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  resetAt: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
});

// Backwards compatible aliases (legacy helpers still referenced in older modules/tests)
export const normalizeHeroTier = normalizeTier;
export const normalizeHeroUsageSnapshot = normalizeUsageSnapshot;

